import React from 'react';

const Pay = () => {
    return (
        <div className="p-5 m-5">
            <h2>Payment system coming soon.</h2>
            <img src="https://i.ibb.co/VVF0sQq/timer.gif" alt="" />
        </div>
    );
};

export default Pay;